module.exports = __webpack_public_path__ + "img/barcode-example-2.beb48803.png";